import classNames from 'classnames'
import { usePartnerId } from 'legacy/lut/classes/helpers/partner360/usePartnerId'
import { usePartnerInfo } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'
import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormPBMManagers } from 'legacy/lut/classes/models/partner360/IFormPBMManagers'
import { CommitmentTypeGroup } from 'legacy/lut/components/widgets/public/partner360/commitment/commitmentTypeGroup/CommitmentTypeGroup'
import { DeleteDialog } from 'legacy/lut/components/widgets/public/partner360/commitment/dialogs/deleteDialog/DeleteDialog'
import { ManagerChangeDialog } from 'legacy/lut/components/widgets/public/partner360/commitment/dialogs/managerChangeDalog/ManagerSelectDialog'
import { PartnerChangeDialog } from 'legacy/lut/components/widgets/public/partner360/commitment/dialogs/partnerChangeDialog/PartnerChangeDialog'
import { generatePartnerPlan } from 'legacy/lut/components/widgets/public/partner360/commitment/helpers/generatePartnerPlan'
import { useCommitmentActions } from 'legacy/lut/components/widgets/public/partner360/commitment/hooks/useCommitmentActions'
import { SkeletonLoader } from 'legacy/lut/components/widgets/public/partner360/commitment/loader/SkeletonLoader'
import { ReviewPlan } from 'legacy/lut/components/widgets/public/partner360/commitment/reviewPlan/ReviewPlan'
import { useScrollToUrlTarget } from 'legacy/lut/components/widgets/public/partner360/hooks/useScrollToUrlTarget'
import { HPContactsTable } from 'legacy/lut/components/widgets/public/partner360/hpContactsTable/HPContactsTable'
import {
  IRequestCommitmentItemsParameters,
  requestCommitmentItems,
  selectCommitmentItemsByProgramType,
  selectCommitmentItemsLoadingStatus,
} from 'legacy/lut/features/partner360/commitment'
import { selectCurrentCompleteness } from 'legacy/lut/features/partner360/completeness'
import {
  selectConfigurationLoadingStatus,
  selectFinancialYear,
  selectPartnerAccess,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { selectGeoRegion } from 'legacy/lut/features/partner360/configuration/selectors/selectGeoRegion'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { TabButtons } from 'legacy/lut/library/tabButtons'
import { getCrudCommitment } from 'legacy/lut/services/partner360/commitment/helpers/getCrudCommitment'
import { getCrudPBMToManagers } from 'legacy/lut/services/partner360/commitment/helpers/getCrudPBMToManagers'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'
import { appGetState } from 'legacy/lut/store'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import sanitize from 'sanitize-html'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { Translation } from 'cng-common/features/translations/components/translation'
import { IForm } from 'core-components/classes/models/IForm'
import { ModalDialog } from 'core-components/library/modalDialog'
import { NotificationController } from 'core-components/library/popup'
import { Progress } from 'core-components/library/progress'
import { Logic, Operator } from 'core-components/types'
import { useMeasureController } from 'core/analytics/useMeasureController'
import { toFormat } from 'core/classes/helpers/DateHelper'
import { CrudStore } from 'core/types/crudStore'
import { ConfirmationDialog as P360ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'
import { WarningIcon } from 'partner360/components/QBR/shared/warningIcon/WarningIcon'
import { ICompletenessInfo } from 'partner360/entities/partnerCompleteness'
import { isPlanReviewBeforeSign, PlanReviewDialog } from 'partner360/features/planReview'
import {
  GpContactsListDialog,
  IJbpGlobalPartnerPartnersContact,
} from 'partner360/widgets/gp360ContactsTable/components/gpContactsListDialog'

import { CommitmentDropEditor } from './commitment/CommitmentDropEditor'
import { CommitmentEditor } from './commitment/CommitmentEditor'
import { CommitmentHistory } from './commitment/CommitmentHistory'
import { AcknowledgmentAction } from './commitment/enums/AckonwledgmentAction'
import { TranslationKeys } from './commitment/enums/TranslationKeys'
import { getCardTypesOrder } from './commitment/helpers/getCardTypesOrder'
import { getClassSelector } from './commitment/helpers/getClassSelector'
import { getSignOffButtonCaption } from './commitment/helpers/getSignOffButtonCaption'
import { reloadSign } from './commitment/helpers/reloadSign'
import { CommitmentTypes, ICommitmentEditorItem, ICommitmentEditorProps } from './commitment/models'
import { ITabProps } from './p360Tabs'
import { ConfirmationDialog } from './programsManagementAdmin/ConfirmationDialog'
import { WidgetHeader } from './widgetHeader/WidgetHeader'

import styles from './CommitmentWrapper.module.scss'

const ACKNOWLEDGMENT_SCROLL_OFFSET = 120
const ACKNOWLEDGMENT_SCROLL_DELAY_MS = 150
const ACKNOWLEDGMENT_SCROLL_URL_KEY = 'ack-section'

export const CommitmentWrapper = (props: ITabProps) => {
  const dispatch = useAppDispatch()

  const [currentItem, setCurrentItem] = useState<ICommitmentEditorItem>()
  const [isRefuseCurrentItem, setIsRefuseCurrentItem] = useState(false)

  const [pbmToManager, setPBMToManager] = useState<IFormPBMManagers>()

  const [blockMessages, setBlockMessages] = useState<IForm[]>([])
  const [warningMessages, setWarningMessages] = useState<IForm[]>([])
  const [currentBlockMessage, setCurrentBlockMessage] = useState('')
  const [currentWarningMessage, setCurrentWarningMessage] = useState('')

  const [isLoaded, setIsLoaded] = useState(true)
  const [progressPercentage, setProgressPercentage] = useState(0)
  const [isBlockRefresh, setIsBlockRefresh] = useState(false)

  const [isShowSignOffDialog, setIsShowSignOffDialog] = useState(false)
  const [isShowPartnerContactDialog, setIsShowPartnerContactDialog] = useState(false)
  const [isShowPartnerContactWarningDialog, setIsShowPartnerContactWarningDialog] = useState(false)
  const [isShowResendDialog, setIsShowResendDialog] = useState(false)
  const [isShowDropDialog, setIsShowDropDialog] = useState(false)
  const [isShowManagerDialog, setIsShowManagerDialog] = useState(false)
  const [isShowWarningDialog, setIsShowWarningDialog] = useState(false)
  const [isShowPbmDialog, setIsShowPbmDialog] = useState(false)
  const [isShowDeleteDialog, setIsShowDeleteDialog] = useState(false)
  const [isDuplicateContactModalOpen, setIsDuplicateContactModalOpen] = useState(false)
  const [isShowPlanReviewDialog, setIsShowPlanReviewDialog] = useState(false)
  // The plan review already asks to sign, so a sign-off coming from it skips the confirmation.
  const [isSignOffReviewed, setIsSignOffReviewed] = useState(false)

  const [selectedTab, setSelectedTab] = useState('1')
  const { jbpSettings } = useJbpSettings()
  const { startLoadData, stopLoadData } = useMeasureController(props.metrics)

  const partnerId = usePartnerId(props.widgetParams, props.pid)

  const crudCommitment = getCrudCommitment()
  const crudPBMToManagers = getCrudPBMToManagers()

  const isPartnerUser = !!appGetState().user.roleIds.find((role: any) => role === 'Partner User')

  const { partnerInfo, triggerCompleteness } = usePartnerInfo({
    partnerId,
    programType: props.programType,
  })
  const isGlobalPartner = useMemo(() => partnerInfo?.IsGlobal === 1, [partnerInfo?.IsGlobal])
  const commitmentData = useSelector(selectCurrentCompleteness)
  const commitmentItems = useSelector(selectCommitmentItemsByProgramType)
  const commitmentItemsStatus = useSelector(selectCommitmentItemsLoadingStatus)
  const configStatus = useSelector(selectConfigurationLoadingStatus)
  const programType = useSelector(selectProgramType)
  const geoRegion = useSelector(selectGeoRegion)
  const fYear = useSelector(selectFinancialYear)
  const { isPower, isDistributor } = useSelector(selectPartnerAccess)
  /** The plan review (plan quality) step of the acknowledgment is limited to testers for now. */
  const { isP360Tester } = useUserRoles()

  const checkContactIsUnique = useCallback(
    (email: string) => {
      const isUnique = !commitmentItems.some(({ SignerEmail }) => SignerEmail === email)

      if (!isUnique) {
        setIsDuplicateContactModalOpen(true)
      }

      return isUnique
    },
    [commitmentItems]
  )

  const { onChangePbm, onDeleteApprover, callAcknowledgmentAction } = useCommitmentActions({
    setIsShowPbmDialog,
    setCurrentItem,
    currentItem,
    setIsShowDeleteDialog,
    checkContactIsUnique,
  })

  const isCommitmentLoading = useMemo(() => {
    return commitmentItemsStatus === RequestStatus.PENDING
  }, [commitmentItemsStatus])

  const isConfigLoading = useMemo(() => {
    return configStatus === RequestStatus.PENDING
  }, [configStatus])

  const cardTypesOrder = useMemo(() => {
    return getCardTypesOrder(geoRegion, commitmentItems)
  }, [geoRegion, commitmentItems])

  const acknowledgmentScrollWatchKey = useMemo(() => {
    return `${cardTypesOrder.join('|')}::${Boolean(commitmentData?.acknowledgementWarning)}`
  }, [cardTypesOrder, commitmentData?.acknowledgementWarning])

  useEffect(() => {
    if (isBlockRefresh) {
      return
    }
    if (partnerInfo) {
      const completenessData = JSON.parse(partnerInfo.Completeness ?? '[]') as ICompletenessInfo[]
      if (completenessData && completenessData.length) {
        setBlockMessages(
          completenessData.map((el) => ({
            key: el.Profile,
            value: el.BlockMessage ?? '',
          }))
        )
        setWarningMessages(
          completenessData.map((el) => ({
            key: el.Profile,
            value: el.WarningMessage ?? '',
          }))
        )
      }
    }
  }, [isBlockRefresh, partnerInfo])

  const fetchData = useCallback(
    async (payload: IRequestCommitmentItemsParameters) => {
      startLoadData()
      await dispatch(requestCommitmentItems(payload))
      stopLoadData()
    },
    [dispatch, startLoadData, stopLoadData]
  )

  const handleGPSelect = useCallback(
    async (selectedProfile: IJbpGlobalPartnerPartnersContact) => {
      if (!currentItem) {
        return
      }

      setIsShowPartnerContactDialog(false)
      if (selectedProfile.Email && !checkContactIsUnique(selectedProfile.Email)) {
        return
      }
      await callAcknowledgmentAction({
        partnerId: currentItem.PartnerId,
        fYear: currentItem.FYear,
        programType: currentItem.ProgramType,
        entryId: null,
        actionData: {
          Action: AcknowledgmentAction.Add,
          Email: selectedProfile.Email,
          FirstName: selectedProfile.FirstName,
          LastName: selectedProfile.LastName,
          ContactId: selectedProfile.ContactID,
          CommitmentType: currentItem.CommitmentType,
        },
      })
    },
    [checkContactIsUnique, currentItem, callAcknowledgmentAction]
  )

  useEffect(() => {
    if (partnerId && fYear && programType) {
      crudCommitment.setFilter({
        logic: Logic.AND,
        filters: [
          {
            field: 'PartnerID',
            operator: Operator.EQUAL,
            value: partnerId,
          },
          {
            field: 'FYear',
            operator: Operator.EQUAL,
            value: fYear,
          },
          {
            field: 'ProgramType',
            operator: Operator.EQUAL,
            value: programType,
          },
        ],
      })
    }
  }, [partnerId, fYear, programType, crudCommitment])

  const confirmManagerHandler = useCallback(
    async (item: ICommitmentEditorItem) => {
      try {
        setIsLoaded(false)

        const isNew = !item.EntryId950

        const pbmToManagerEntry = isNew
          ? {
              EntryId: 0,
              PBMConfirmed: 1,
              ProgramType: programType,
              PBMEmail: item.PBMEmail,
              ManagerEmail: item.SignerEmail,
              ManagerFirstName: item.SignerFirstName,
              ManagerLastName: item.SignerLastName,
            }
          : {
              EntryId: item.EntryId950,
              PBMConfirmed: 1,
            }
        const method = isNew ? crudPBMToManagers.create : crudPBMToManagers.update
        await method({ formId: '950', code: 'pbm-managers-950' }, [pbmToManagerEntry])

        await fetchData({ partnerId, fYear, programType })
        await triggerCompleteness()
      } catch (e: any) {
        NotificationController.showError({
          message: `Please, try again later. Error: ${e.message}`,
        })
      } finally {
        setIsLoaded(true)
      }
    },
    [partnerId, fYear, programType, crudPBMToManagers, fetchData, triggerCompleteness]
  )

  useEffect(() => {
    const val = blockMessages.find((el: IForm) => el.key === programType)
    setCurrentBlockMessage((val || {})['value'] || '')
  }, [programType, blockMessages])

  useEffect(() => {
    const val = warningMessages.find((el: IForm) => el.key === programType)
    setCurrentWarningMessage((val || {})['value'] || '')
  }, [programType, warningMessages])

  useScrollToUrlTarget({
    enabled: selectedTab === '1' && isLoaded && !isCommitmentLoading && !isConfigLoading,
    urlKey: ACKNOWLEDGMENT_SCROLL_URL_KEY,
    watchKey: acknowledgmentScrollWatchKey,
    offset: ACKNOWLEDGMENT_SCROLL_OFFSET,
    delayMs: ACKNOWLEDGMENT_SCROLL_DELAY_MS,
  })

  const getIsPBMSigned = (): boolean => {
    let isPBMSigned: boolean = false
    commitmentItems.map((commitmentItem: ICommitmentData) => {
      if (commitmentItem.CommitmentType === CommitmentTypes.PBM && commitmentItem.SignerEmail) {
        isPBMSigned = true
      }
    })
    return isPBMSigned
  }

  if (!isLoaded || isCommitmentLoading || isConfigLoading) {
    return progressPercentage > 0 && progressPercentage < 100 ? (
      <>
        <div className={styles.progressText}>
          <Translation text="jbp-partnercommitment-wait-for-report" />
        </div>
        <Progress
          minValue={0}
          maxValue={100}
          step={1}
          value={progressPercentage}
          className={styles.progress}
        />
      </>
    ) : (
      <SkeletonLoader cols={3} />
    )
  }

  const applySignOff = async (item: IForm, refuseComment?: string) => {
    setIsShowSignOffDialog(false)
    if (refuseComment) {
      setIsRefuseCurrentItem(false)
    }
    const actionData = refuseComment
      ? {
          Action: AcknowledgmentAction.Refuse,
          Comment: refuseComment,
          CommitmentType: currentItem?.CommitmentType,
        }
      : {
          Action: AcknowledgmentAction.SignOff,
          CommitmentType: currentItem?.CommitmentType,
        }
    setIsLoaded(false)
    await callAcknowledgmentAction({
      partnerId: item.PartnerId,
      fYear: item.FYear,
      programType: item.ProgramType,
      entryId: item.EntryId,
      actionData,
    })

    const isGenerateSuccess = await generatePartnerPlan({
      setIsBlockRefresh,
      setProgressPercentage,
      setIsRefuseCurrentItem,
      jbpSettings,
      partnerId,
      partnerInfo,
      programType,
      item,
      fyear: fYear,
    })

    if (!isGenerateSuccess) {
      await callAcknowledgmentAction({
        partnerId: item.PartnerId,
        fYear: item.FYear,
        programType: item.ProgramType,
        entryId: item.EntryId,
        actionData: {
          Action: AcknowledgmentAction.Drop,
          Comment:
            '[System error]: Failed to generate the plan PDF, therefore the commitment was cancelled.',
          CommitmentType: currentItem?.CommitmentType,
        },
      })
    }
    setIsLoaded(true)

    await triggerCompleteness()
  }

  const openSignOffConfirmation = (item: ICommitmentEditorItem, isReviewed = false) => {
    const showWarning = !!currentWarningMessage && item.CommitmentType === CommitmentTypes.Partner

    setIsSignOffReviewed(isReviewed)

    if (showWarning) {
      setIsShowWarningDialog(true)
    } else if (isReviewed) {
      void applySignOff(item)
    } else {
      setIsShowSignOffDialog(true)
    }
  }

  const getProps = (commitmentItem: ICommitmentData): ICommitmentEditorProps => {
    return {
      pid: partnerId,
      widgetParams: props,
      commitmentEditorItem: {
        ...commitmentItem,
        CanSignOnBehalf: false,
        IsPBMSigned: getIsPBMSigned(),
      },
      fyear: fYear,
      programType,
      isPower: isPower,
      isDistributor: isDistributor,
      canEditPartner: true,
      currentBlockMessage: currentBlockMessage,
      showSignOffDialog: (show: boolean, item: ICommitmentEditorItem) => {
        if (show) {
          setCurrentItem(item)

          if (isP360Tester && isPlanReviewBeforeSign(fYear)) {
            setIsShowPlanReviewDialog(true)
          } else {
            openSignOffConfirmation(item)
          }
        }
      },
      showRefuseDialog: (show: boolean, item: ICommitmentEditorItem) => {
        if (show) {
          setIsRefuseCurrentItem(true)
          setCurrentItem(item)

          const showWarning =
            !!currentWarningMessage && item.CommitmentType === CommitmentTypes.Partner
          if (showWarning) {
            setIsShowWarningDialog(true)
          } else {
            setIsShowSignOffDialog(show)
          }
        }
      },
      showResendDialog: (show: boolean, item: ICommitmentEditorItem) => {
        if (show) {
          setCurrentItem(item)
          setIsShowResendDialog(show)
        }
      },
      showDropDialog: (show: boolean, item: ICommitmentEditorItem) => {
        if (show) {
          setCurrentItem(item)
          setIsShowDropDialog(show)
        }
      },
      showPbmDialog: (show: boolean, item: ICommitmentEditorItem) => {
        setCurrentItem(item)
        setIsShowPbmDialog(show)
      },
      showManagerDialog: (show: boolean, item: ICommitmentEditorItem) => {
        if (show) {
          const newPBMToManager = {
            EntryId: item.EntryId950,
            ManagerEmail: item.SignerEmail || '',
            ManagerFirstName: item.SignerFirstName || '',
            ManagerLastName: item.SignerLastName || '',
            // more correctly use: item.PBMConfirmed,
            PBMConfirmed: item.CanConfirmManager ? 0 : 1,
            PBMEmail: item.PBMEmail,
            ProgramType: item.ProgramType,
          }
          setPBMToManager(newPBMToManager)
          setIsShowManagerDialog(show)
          setCurrentItem(item)
        }
      },
      confirmManager: confirmManagerHandler,
      showSelectPartnerContactDialog: (show: boolean, item: ICommitmentEditorItem) => {
        if (show) {
          setCurrentItem(item)

          const showWarning =
            !!currentWarningMessage && item.CommitmentType === CommitmentTypes.Partner

          if (showWarning) {
            setIsShowPartnerContactWarningDialog(true)
          } else {
            setIsShowPartnerContactDialog(show)
          }
        }
      },
      showDeleteDialog: (item: ICommitmentEditorItem) => {
        setCurrentItem(item)
        setIsShowDeleteDialog(true)
      },
    }
  }

  const tabs = [
    {
      id: '1',
      label: 'jbp-commitment',
      content: () => (
        <div className={styles.container}>
          {commitmentData?.acknowledgementWarning && (
            <div className={styles.acknowledgementTextBlock} id="warning">
              <div
                className={classNames(
                  styles.acknowledgementTitle,
                  styles.initiativesPlanMessageWarning
                )}
              >
                <div className={styles.headerWithIcon}>
                  <WarningIcon />
                  <Translation text={'jbp-commitment-warning-header'} />
                </div>
                <div
                  className={styles.warningText}
                  dangerouslySetInnerHTML={{
                    __html: sanitize(commitmentData?.acknowledgementWarning),
                  }}
                />
              </div>
            </div>
          )}
          <div className={styles.grid}>
            {cardTypesOrder.map((type, index) => {
              const classSelector = getClassSelector(index)
              return (
                <div key={type} id={type}>
                  <CommitmentTypeGroup
                    itemClassName={styles[classSelector]}
                    programType={programType}
                    commitmentType={type}
                    getProps={getProps}
                    pid={props.pid}
                    metrics={props.metrics}
                    flexWidth={props.flexWidth}
                    partnerId={partnerId}
                    fyear={fYear}
                    setIsRefuseCurrentItem={setIsRefuseCurrentItem}
                    commitmentItems={commitmentItems}
                    checkContactIsUnique={checkContactIsUnique}
                  />
                </div>
              )
            })}
          </div>
        </div>
      ),
    },
    {
      id: '2',
      label: 'jbp-commitment-history',
      content: () => (
        <CommitmentHistory
          isDistributor={isDistributor}
          widgetParams={props}
          partnerId={partnerId}
          fyear={fYear}
          programType={programType}
        />
      ),
    },
  ]

  if (!commitmentItems.length) {
    return (
      <div className={styles.noData}>
        <Translation text={TranslationKeys.NoData} />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <ReviewPlan />
      <TabButtons items={tabs} onChange={setSelectedTab} value={selectedTab} />

      <PlanReviewDialog
        show={
          isP360Tester && isPlanReviewBeforeSign(fYear) && isShowPlanReviewDialog && !!currentItem
        }
        partnerId={partnerId}
        fYear={fYear}
        programType={programType}
        isGlobal={isGlobalPartner}
        role={currentItem?.CommitmentType ?? CommitmentTypes.PBM}
        showSummary
        continueCaption={currentItem && getSignOffButtonCaption(currentItem, isPartnerUser)}
        onClose={() => setIsShowPlanReviewDialog(false)}
        onContinue={() => {
          setIsShowPlanReviewDialog(false)
          setIsRefuseCurrentItem(false)

          if (currentItem) {
            openSignOffConfirmation(currentItem, true)
          }
        }}
        onReject={() => {
          setIsShowPlanReviewDialog(false)
          setIsRefuseCurrentItem(true)

          if (currentItem) {
            openSignOffConfirmation(currentItem)
          }
        }}
      />

      <ModalDialog
        show={isShowWarningDialog}
        size={'xs'}
        content={ConfirmationDialog}
        contentProps={{
          text: currentWarningMessage,
          submitText: 'jbp-continue',
          translation: true,
          onClick: async (submit: boolean) => {
            setIsShowWarningDialog(false)

            if (submit) {
              //const pI =
              //  partnerSigner.item && partnerSigner.item.Dropped
              //    ? {
              //        ...partnerSignerDefault,
              //        item: partnerSigner.item,
              //      }
              //    : { ...partnerSigner }
              //if (pI.date == null) {
              //  pI.date = currentTime
              //}
              //setCurrentItem(pI)
              //setShowDialog(true)

              if (isSignOffReviewed && !isRefuseCurrentItem && currentItem) {
                void applySignOff(currentItem)
              } else {
                setIsShowSignOffDialog(true)
              }
            } else {
              isRefuseCurrentItem && setIsRefuseCurrentItem(false)
            }
          },
        }}
        onClose={() => {
          setIsShowWarningDialog(false)
          isRefuseCurrentItem && setIsRefuseCurrentItem(false)
        }}
      />

      <ModalDialog
        show={isShowPartnerContactWarningDialog}
        size={'xs'}
        content={ConfirmationDialog}
        contentProps={{
          text: currentWarningMessage,
          submitText: 'jbp-continue',
          translation: true,
          onClick: async (submit: boolean) => {
            setIsShowPartnerContactWarningDialog(false)

            if (submit) {
              setIsShowPartnerContactDialog(true)
            }
          },
        }}
        onClose={() => {
          setIsShowPartnerContactWarningDialog(false)
        }}
      />
      <ManagerChangeDialog
        pbmToManager={pbmToManager}
        onClose={() => setIsShowManagerDialog(false)}
        show={isShowManagerDialog}
        action={currentItem?.CanChange ? AcknowledgmentAction.Change : AcknowledgmentAction.Select}
        ackItem={currentItem}
        checkContactIsUnique={checkContactIsUnique}
      />

      {isGlobalPartner ? (
        <GpContactsListDialog
          showModal={isShowPartnerContactDialog}
          setShowModal={setIsShowPartnerContactDialog}
          partnerId={partnerId}
          metrics={props.metrics}
          flexWidth={props.flexWidth}
          fYear={fYear}
          onSelectProfile={handleGPSelect}
        />
      ) : (
        <PartnerChangeDialog
          checkContactIsUnique={checkContactIsUnique}
          show={isShowPartnerContactDialog}
          partnerId={partnerId}
          setIsRefuseCurrentItem={setIsRefuseCurrentItem}
          onClose={() => setIsShowPartnerContactDialog(false)}
          action={
            currentItem?.CanChange ? AcknowledgmentAction.Change : AcknowledgmentAction.Select
          }
          ackItem={currentItem}
        />
      )}
      <ModalDialog
        show={isShowDropDialog}
        size={'sm'}
        content={CommitmentDropEditor}
        contentProps={{
          item: currentItem || {},
          onApply: async (item: IForm) => {
            setIsShowDropDialog(false)
            if (item.EntryId) {
              try {
                await callAcknowledgmentAction({
                  partnerId: item.PartnerId,
                  fYear: item.FYear,
                  programType: item.ProgramType,
                  entryId: item.EntryId,
                  actionData: {
                    Action: AcknowledgmentAction.Drop,
                    Comment: item.Comment,
                    CommitmentType: currentItem?.CommitmentType,
                  },
                })

                const crud = CrudStore.get(CrudStoreItemPartner360.CountryManagerSummary)
                const crudDistributors = CrudStore.get(
                  CrudStoreItemPartner360.CountryManagerSummaryDistributors
                )
                const countryManagerCrudRetailers = CrudStore.get(
                  CrudStoreItemPartner360.CountryManagerSummaryRetailers
                )
                crud.removeQueries(true)
                crudDistributors.removeQueries(true)
                crudCommitment.removeQueries(true)
                countryManagerCrudRetailers.removeQueries(true)

                // TODO: We need it?
                reloadSign(item)
                await triggerCompleteness()
              } catch (e: any) {
                NotificationController.showError({
                  message: `Please, try again later. Error: ${e.message}`,
                })
              } finally {
                //loading(false) && setLoading(false)
              }
            }
          },
        }}
        onClose={() => setIsShowDropDialog(false)}
      />

      <ModalDialog
        show={isShowSignOffDialog}
        size={'sm'}
        content={CommitmentEditor}
        header={() => (
          <WidgetHeader className={styles.modalDialogHeader}>{currentItem?.HeaderKey}</WidgetHeader>
        )}
        contentProps={{
          pid: partnerId,
          metrics: props.metrics,
          flexWidth: props.flexWidth,

          item: currentItem || {},
          refuse: isRefuseCurrentItem,
          canSign: true,
          canSignOnBehalf: fYear < 2022,
          isPartnerUser: isPartnerUser,

          onCancel: () => {
            setIsShowSignOffDialog(false)
            setIsRefuseCurrentItem(false)
          },
          onApply: applySignOff,
        }}
        onClose={() => {
          setIsShowSignOffDialog(false)
          setIsRefuseCurrentItem(false)
        }}
      />

      <ModalDialog
        show={isShowResendDialog}
        size={'xs'}
        content={ConfirmationDialog}
        contentProps={{
          text: 'jbp-commitment-resend-confirmation',
          htmlAvailable: true,
          replaceParams: [
            {
              key: '[date]',
              value: toFormat(currentItem?.EmailSentDate || '', 'DD MMM YYYY HH:mm'),
            },
          ],
          submitText: 'jbp-commitment-resend',
          translation: true,
          onClick: async (submit: boolean) => {
            setIsShowResendDialog(false)

            if (!submit) {
              return
            }

            if (currentItem) {
              await callAcknowledgmentAction({
                partnerId: currentItem.PartnerId,
                fYear: currentItem.FYear,
                programType: currentItem.ProgramType,
                entryId: currentItem?.EntryId,
                actionData: {
                  Action: AcknowledgmentAction.Resend,
                  CommitmentType: currentItem.CommitmentType,
                },
              })
            }
            setIsBlockRefresh(false)
          },
        }}
        onClose={() => setIsShowResendDialog(false)}
      />
      <ModalDialog
        content={() => (
          <HPContactsTable
            widgetParams={props.widgetParams}
            pid={props.pid}
            metrics={props.metrics}
            flexWidth={props.flexWidth}
            settings={{
              showRoleColumn: true,
              hideRoleDropdown: true,
              onSelectRow: onChangePbm,
              sourceKey: 'multiple-approvers',
              fetchAllRoles: true,
            }}
          />
        )}
        show={isShowPbmDialog}
        closeOnOutsideClick={false}
        onClose={() => {
          setIsShowPbmDialog(false)
          setCurrentItem(undefined)
        }}
      />
      <DeleteDialog
        showDialog={isShowDeleteDialog}
        onDelete={onDeleteApprover(currentItem)}
        onClose={() => {
          setIsShowDeleteDialog(false)
          setCurrentItem(undefined)
        }}
      />
      <P360ConfirmationDialog
        isOnlyApply
        confirmBtnText={'jbp-commitment-unique-warning-confirm'}
        content={'jbp-commitment-unique-warning-content'}
        isVisible={isDuplicateContactModalOpen}
        onConfirm={() => setIsDuplicateContactModalOpen(false)}
        title={'jbp-commitment-unique-warning-title'}
      />
    </div>
  )
}

export default CommitmentWrapper
